import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import LoginFunctions from "./LoginFunctions";
import { publicIP } from "shared/util/public-ip/publc-ip";
import { ViewStateEnum } from "constants/EnumViewState";
import TextInput from "shared/components/input/TextInput";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { LoginSchema } from "shared/yup/schemas/LoginSchema";

interface LoginProps {
  changeViewState: (value: ViewStateEnum) => void;
}

export interface LoginForm {
  email: string;
  senha: string;
}

const Login: React.FC<LoginProps> = (props) => {
  const [ip, setIp] = useState<string>("0.0.0.0");
  const [renderError, setRenderErro] = useState<boolean>(false);
  const [disableLoginButton, setDisableLoginButton] = useState<boolean>(false);
  const [isAttemptLimit, setIsAttemptLimit] = useState<boolean>(false);
  const [attempt, setAttempt] = useState<number>(0);
  const [timer, setTimer] = useState<number>(30);
  const { login, handleStartTime } = LoginFunctions();

  const { register, control, handleSubmit, getValues, setValue } = useForm<LoginForm>({
    resolver: yupResolver<LoginForm>(LoginSchema),
  });

  useEffect(() => {
    publicIP().then((res) => setIp(res?.ip));
  }, []);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit(handleLogin)();
    }
  };

  const handleLogin = async () => {
    if (attempt < 3) {
      await login(getValues("email"), getValues("senha"), ip, setRenderErro);
    } else {
      handleStartTime(
        setDisableLoginButton,
        timer,
        setTimer,
        setAttempt,
        setRenderErro,
        setIsAttemptLimit
      );
    }
    let count = attempt + 1;
    setAttempt(count);
  };

  const renderHeaderLogin = () => {
    return (
      <div className="d-flex flex-column text-center mt-5">
        <div className="fs-4 mb-2">
          Bem vindo(a), ao <b>Group</b> Condomínios!
        </div>
        <div style={{ fontSize: "2.5vh" }}>A melhor plataforma de gestão condominial em nuvem.</div>
      </div>
    );
  };

  const renderCampoEmail = () => {
    return (
      <TextInput
        name="email"
        id="email"
        className="mb-2"
        control={control}
        label="E-mail"
        placeholder="Digite seu e-mail"
        register={register}
        usarValidacaoParaFormulario
        setValue={setValue}
      />
    );
  };

  const renderCampoSenha = () => {
    return (
      <TextInput
        control={control}
        name="senha"
        id="senha"
        register={register}
        label="Senha"
        placeholder="Digite sua senha"
        usarValidacaoParaFormulario
        setValue={setValue}
        isPassword
        onKeyDown={handleKeyDown}
      />
    );
  };

  const renderForgotPassword = () => {
    return (
      <Form.Group>
        <div className="text-center mt-2">
          <Form.Text>
            Esqueceu a senha?
            <span
              onClick={() => props.changeViewState(ViewStateEnum.FORGOT_PASSWORD)}
              className={"esqueceu-senha"}
            >
              &nbsp;Veja como recuperar
            </span>
          </Form.Text>
        </div>
      </Form.Group>
    );
  };

  const renderSubmitButton = () => {
    return (
      <div className="d-grid gap-2 mt-5">
        {renderError && (
          <div className={"credenciais-invalidas"}>
            {isAttemptLimit
              ? `Login bloqueado, tente novamente em ${timer} segundos`
              : "Credenciais inválidas"}
          </div>
        )}
        <button
          className={"botao-entrar"}
          style={{ cursor: disableLoginButton ? "not-allowed" : "" }}
          type="button"
          disabled={disableLoginButton}
          onClick={handleSubmit(handleLogin)}
        >
          Entrar
        </button>
      </div>
    );
  };

  const renderLogin = () => {
    return (
      <div className={"main-login"}>
        {renderHeaderLogin()}
        <div className="p-5">
          <Form>
            {renderCampoEmail()}
            {renderCampoSenha()}
            {renderForgotPassword()}
            {renderSubmitButton()}
          </Form>
        </div>
      </div>
    );
  };

  return <div>{renderLogin()}</div>;
};

export default Login;
